// extracted by mini-css-extract-plugin
export default {"title":"Projects_title__Qi8X8","project-name":"Projects_project-name__NPf+H","links":"Projects_links__Qvn+v","projectSeparator":"Projects_projectSeparator__F6gyo"};